import { trackPromise } from 'react-promise-tracker';

import api from '../../../../../utils/API';

import { PriceArchitectureConfigResponse, SavePriceArchitectureConfigPayload } from './types';

const getPriceArchitectureConfigUrl = () => `${process.env.REACT_APP_IPA_URL}/setup/architecture-config`;

export function getPriceArchitectureConfig(): Promise<PriceArchitectureConfigResponse> {
  return trackPromise(
    api({
      url: getPriceArchitectureConfigUrl(),
      method: 'GET',
      expectToken: true,
    }).then(response => response.data),
    '',
  );
}

export function savePriceArchitectureConfig(payload: SavePriceArchitectureConfigPayload): Promise<PriceArchitectureConfigResponse | void> {
  return trackPromise(
    api({
      url: getPriceArchitectureConfigUrl(),
      method: 'POST',
      data: payload,
      expectToken: true,
    }).then(response => response.data),
    '',
  );
}
